import AlertCircleOutlineIcon from 'mdi-react/AlertCircleOutlineIcon'
import { twJoin } from 'tailwind-merge'

export const WarningIcon = ({ isUrgent = false }) => {
  return (
    <AlertCircleOutlineIcon
      className={twJoin('ml-1.5', isUrgent ? 'text-red' : 'text-[#f3b134]')}
    />
  )
}
